import { ClarityUnmaskDirective } from 'app/shared/directives/clarity-unmask.directive';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AuthService } from '@service-features/auth.service';
import { ApiErrorAdapter } from '@shared-services/handlers/api-error-adapter.service';
import { firstValueFrom } from 'rxjs';
import { InlineSpinnerComponent } from '@shared-components/inline-spinner/inline-spinner.component';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    InlineSpinnerComponent,
    ClarityUnmaskDirective,
    CommonModule,
    ReactiveFormsModule,
    RouterLink,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  readonly email = new FormControl('', {
    nonNullable: true,
    validators: [Validators.required, Validators.email],
  });
  loading = false;
  successMessage = '';
  errorMessage = '';
  constructor(
    private auth: AuthService,
    private errors: ApiErrorAdapter,
  ) {}
  async submit(): Promise<void> {
    if (this.email.invalid || this.loading) {
      this.email.markAsTouched();
      return;
    }
    this.loading = true;
    this.errorMessage = '';
    try {
      const response = await firstValueFrom(
        this.auth.forgotPassword(this.email.value),
      );
      this.successMessage = response.payload;
    } catch (error: unknown) {
      this.errorMessage = this.errors.from(error).message;
    } finally {
      this.loading = false;
    }
  }
}
